import React from 'react';
import {
  Card,
  Spin,
  Row,
  Col,
  Alert
} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router'
import StationToolbar from '../components/StationToolbar'
import StationCardDeviceLayout from '../components/StationCardDeviceLayout'
import ModalDeviceRelay from '../components/ModalDeviceRelay'

import {fetchStationPresentation, postDeviceCommand} from '../actions/station'
import {fetchCameras} from '../actions/camera'
import {subcribeTopic, unsubcribeTopic} from '../actions/mqtt'
import {fetchChartDeviceData} from '../actions/chart'
import {timeConverterSimple, getDateConverterSimple} from '../utils'

import {CHANNEL_STATION_CONNECTION_STATUS, CHANELL_NEW_STATUS, CHANNEL_EVENT_BOTH, CHANNEL_NEW_CONFIG} from '../constants/defaultValues'

class StationPresentationLayout extends React.Component {
  state = {
    visibleModalDeviceRelay: false,
    titleModalDeviceRelay: '',
    currentDevice: {}
  }

  componentWillMount() {
    this.props.dispatch(fetchStationPresentation())
  }

  componentDidMount() {
    const {currentSystem, currentStation} = this.props
    const systemID = currentSystem.ID
    const stationID = currentStation.ID
    const topics = [`${CHANNEL_STATION_CONNECTION_STATUS}/${systemID}/${stationID}`, `${CHANELL_NEW_STATUS}/${currentSystem.ID}/${currentStation.ID}`, `${CHANNEL_EVENT_BOTH}/${systemID}/${stationID}`, `${CHANNEL_NEW_CONFIG}/${systemID}/${stationID}`]
    this.props.dispatch(subcribeTopic(topics))
    this.props.dispatch(fetchCameras())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.devices) {
      const {currentDevice} = this.state
      const device = nextProps.devices.find((dev) => {
        return dev.DeviceId === currentDevice.DeviceId
      });
      if (device) {
        this.setState({currentDevice: device})
      }
    }
  }

  componentWillUnmount() {
    const {currentSystem, currentStation} = this.props
    const systemID = currentSystem.ID
    const stationID = currentStation.ID
    const topics = [`${CHANNEL_STATION_CONNECTION_STATUS}/${systemID}/${stationID}`, `${CHANELL_NEW_STATUS}/${currentSystem.ID}/${currentStation.ID}`, `${CHANNEL_EVENT_BOTH}/${systemID}/${stationID}`, `${CHANNEL_NEW_CONFIG}/${systemID}/${stationID}`]
    this.props.dispatch(unsubcribeTopic(topics))
  }

  handleDeviceRelayClick(dev) {
    this.setState({visibleModalDeviceRelay: true, titleModalDeviceRelay: dev.Name, currentDevice: dev});
  }

  handleCancelModalDeviceRelay() {
    this.setState({visibleModalDeviceRelay: false});
  }

  handleCmdOn() {
    const devId = this.state.currentDevice.DeviceId
    const data = btoa(JSON.stringify({
      DeviceId: devId,
      Delay: 0,
      CommandValue: 1,
      Duration: 0,
      NextValue: 0,
      RepeatCycle: 0,
      RepeatCount: 0
    }));
    const station = this.props.currentStation
    const command = {
      StationID: station.ID,
      CategoryID: devId,
      Data: data
    }
    this.props.dispatch(postDeviceCommand(command))
  }

  handleCmdOff() {
    const devId = this.state.currentDevice.DeviceId
    const data = btoa(JSON.stringify({
      DeviceId: devId,
      Delay: 0,
      CommandValue: 0,
      Duration: 0,
      NextValue: 0,
      RepeatCycle: 0,
      RepeatCount: 0
    }));
    const station = this.props.currentStation
    const command = {
      StationID: station.ID,
      CategoryID: devId,
      Data: data
    }
    this.props.dispatch(postDeviceCommand(command))
  }

  handleTimeLineClick(dev) {
    const {currentStation} = this.props
    const linkTo = `station/${currentStation.ID}/datas`
    const from =  getDateConverterSimple(new Date().getTime()/1000)
    const to = getDateConverterSimple(new Date().getTime()/1000)

    this.props.dispatch(fetchChartDeviceData(dev, from+" 00:00:00", to+" 23:59:58", 0, 20000))
    hashHistory.push(linkTo)
  }

  render() {
    const {
      currentSystem,
      currentStation,
      rooms,
      devices,
      scripts,
      events,
      fetchingDevices,
      fetchingRecentEvent,
      receiving,
      sending,
      error,
      clientHeight,
      isMobile,
      location
    } = this.props
    const bodyStyle = {
      height: clientHeight
    }
    const breadcrumbs = [
      {
        Name: "Giám sát",
        Link: `/${currentSystem.ID}/presentation`
      }, {
        Name: currentStation.Name,
        Link: ""
      }
    ]

    const elDevices = !fetchingDevices
      ? <StationCardDeviceLayout rooms={rooms} devices={devices} error={error} height={clientHeight} onClick={(dev) => this.handleDeviceRelayClick(dev)}/>
      : <span className="center"><Spin/></span>
    return (<div>
      <StationToolbar location={location} breadcrumbs={breadcrumbs} station={currentStation}/> {
        currentStation.OnlineState === 0
          ? <Alert message={`Trạm mất kết nối tới server lúc: ${timeConverterSimple(currentStation.OnlineTime)}`} type="error" closable="closable"/>
          : null
      }
      <Row align="middle">
        <Col xs={{
            span: 24
          }} sm={{
            span: 24
          }} md={{
            span: 24
          }} lg={{
            span: 24
          }} xl={{
            span: 24
          }}>
          <Card title="Thiết bị" className="card" bodyStyle={bodyStyle} hoverable={false}>{elDevices}</Card>
        </Col>
      </Row>
      <ModalDeviceRelay visible={this.state.visibleModalDeviceRelay} title={this.state.titleModalDeviceRelay} device={this.state.currentDevice} sending={sending} onTimeLineClick={(dev) => this.handleTimeLineClick(dev)} onCmdOn={() => this.handleCmdOn()} onCmdOff={() => this.handleCmdOff()} onCancel={() => this.handleCancelModalDeviceRelay()}/>
    </div>);
  }
}
StationPresentationLayout.propTypes = {
  dispatch: PropTypes.func,
  mqttConnected: PropTypes.bool,
  currentSystem: PropTypes.object,
  currentStation: PropTypes.object,
  devices: PropTypes.array,
  rooms: PropTypes.array,
  scripts: PropTypes.array,
  events: PropTypes.array,
  receiving: PropTypes.bool,
  fetchingDevices: PropTypes.bool,
  fetchingRecentEvent: PropTypes.bool,
  sending: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {
    mqttConnected: state.mqtt.connected,
    currentSystem: state.system.currentSystem,
    currentStation: state.station.currentStation,
    rooms: state.device.rooms,
    devices: state.device.devices,
    scripts: state.device.scripts,
    events: state.device.events,
    receiving: state.device.receivingNewEvents,
    fetchingDevices: state.device.fetchingDevices,
    fetchingRecentEvent: state.device.fetchingRecentEvent,
    sending: state.device.sendingDeviceCommand,
    error: state.device.error
  }
}

export default connect(mapStateToProps)(StationPresentationLayout)



// WEBPACK FOOTER //
// ./src/pages/StationPresentationLayout.js